import { Configuration } from "../../api-models";
import { InternalServerError } from "../../api-models/errors";
import { ApplicationId, SubscriptionEnvironment } from "../../identifiers";
import { Store } from "../../store";
import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { NotFound } from "@effect/platform/HttpApiError";
import { Schema } from "effect";
export const ConfigurationApi = HttpApiGroup.make("configuration").add(HttpApiEndpoint.post("sealString")`/seal`.addSuccess(Schema.Struct({
    sealed: Schema.String
})).setPayload(Schema.Struct({
    unsealed: Schema.String
})).addError(NotFound)).add(HttpApiEndpoint.get("getConfigurationStatus")`/applications/:applicationId/:store/configuration/status`.setPath(Schema.Struct({
    store: Store.Schema,
    applicationId: ApplicationId.FromString
})).addSuccess(Configuration.Status).addError(InternalServerError).annotate(OpenApi.Summary, "GetConfigurationStatus")).add(HttpApiEndpoint.post("updateConfiguration")`/applications/:applicationId/:store/:storeEnvironment/configuration`.setPath(Schema.Struct({
    store: Store.Schema,
    storeEnvironment: SubscriptionEnvironment.Schema,
    applicationId: ApplicationId.FromString
})).setPayload(Schema.Struct({
    keys: Schema.Record({
        key: Schema.String,
        value: Schema.NullishOr(Schema.String)
    })
})).addError(InternalServerError).addSuccess(Schema.Struct({
    valid: Schema.Boolean
})));
